import { BaseChannel, ChannelType } from '@/realtime/channels/baseChannel';
// eslint-disable-next-line import/prefer-default-export
export class PrivateChannel extends BaseChannel {
    constructor(suffix) {
        super(ChannelType.PRIVATE);
        this.setSuffix(suffix);
    }
}
